import { C } from '../actions/index';

const defaultAccountForm = {
  firstName: '',
  lastName: '',
  oldPass: '',
  newPass: '',
  confirmPass: '',
  email: '',
  emailPass: ''
};

export const initialAccountModalState = {
  openAccountModal: false,
  mode: null,
  error: null,
  isPending: false,
  isSuccess: false,
  accountForm: defaultAccountForm
};

export const accountModal = (state = initialAccountModalState, action) => {
  switch (action.type) {
    case C.OPEN_ACCOUNT_MODAL:
      return Object.assign({}, state, {
        openAccountModal: true,
        mode: action.payload
      });
    case C.CLOSE_ACCOUNT_MODAL:
      return Object.assign({}, state, {
        openAccountModal: false,
        error: null,
        isPending: false,
        isSuccess: false,
        accountForm: defaultAccountForm
      });
    case C.NAMECHANGE:
    case C.PASSWORDCHANGE:
    case C.EMAILCHANGE:
      return Object.assign({}, state, {
        error: null,
        isPending: true,
        isSuccess: false
      });
    case C.NAMECHANGE_FAIL:
    case C.PASSWORDCHANGE_FAIL:
    case C.EMAILCHANGE_FAIL:
      return Object.assign({}, state, {
        error: action.error,
        isPending: false,
        isSuccess: false
      });
    case C.NAMECHANGE_SUCCESS:
    case C.PASSWORDCHANGE_SUCCESS:
    case C.EMAILCHANGE_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        isPending: false,
        isSuccess: true
      });
    case C.CHANGE_ACCOUNT_FORM:
      const form = Object.assign({}, state.accountForm);
      form[action.payload.field] = action.payload.newValue;
      return Object.assign({}, state, { accountForm: form });
    default:
      return state;
  }
};
